import { X } from 'lucide-react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Summary, Dashboard } from '|/app/services';
import { SupportContact, SupportMfeModal } from '|/components/support-contact';
import MobileNavigationRailContext from '|/context/mobile-navigation-rail-context';
import mobileStyles from './mobile-navigation-rail.module.css';
import NavigationRail from '../navigation-rail';

interface MobileNavigationRailProps {
  dashboard: Dashboard | null;
  summary: Summary | null;
}

const MobileNavigationRail: React.FC<MobileNavigationRailProps> = ({ dashboard, summary }) => {
  const { showMobileNavigationRail, setShowMobileNavigationRail } = useContext(
    MobileNavigationRailContext
  );
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (showMobileNavigationRail) {
      document.body.className = `${document.body.className} navrail-scroll-lock`;
    } else {
      document.body.className = document.body.className.replace('navrail-scroll-lock', '');
    }
  }, [showMobileNavigationRail]);

  if (dashboard === null || summary === null) {
    return null;
  }

  const handleClose = () => {
    setShowMobileNavigationRail(false);
    if (menuRef.current) {
      menuRef.current.scrollIntoView();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClose();
    }
  };

  return (
    <>
      <div
        className={`${mobileStyles.overlay} ${showMobileNavigationRail ? mobileStyles.show : ''}`}
        onClick={handleClose}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Close navigation"
        data-analytics-id="pp_navrail_overlay"
      />
      <div
        className={`${mobileStyles.mobilePositioning} ${showMobileNavigationRail ? mobileStyles.isOpen : ''}`}
      >
        <div className={mobileStyles.modalHeader} ref={menuRef}>
          <div className={mobileStyles.supportContactWrapper}>
            <SupportContact
              onClick={() => {
                setIsSupportModalOpen(true);
              }}
              onClose={() => {
                setShowMobileNavigationRail(false);
              }}
              data-analytics-id="pp-support-contact"
            />
          </div>
          <button
            className={mobileStyles.closeButton}
            onClick={handleClose}
            data-analytics-id="pp_navrail_close"
          >
            <X size={24} />
          </button>
        </div>
        <div className={mobileStyles.modalContent}>
          <NavigationRail
            dashboard={dashboard}
            summary={summary}
            onNavigate={() => {
              setShowMobileNavigationRail(false);
            }}
          />
        </div>
      </div>

      {/* Support MFE Modal */}
      <SupportMfeModal
        isOpen={isSupportModalOpen}
        onClose={() => {
          setIsSupportModalOpen(false);
        }}
        closeMobileNavMenu={() => {
          setShowMobileNavigationRail(false);
        }}
      />
    </>
  );
};

export default MobileNavigationRail;
